import {useEffect, useRef, useState} from "react";
import {TicketToRidePlayerView} from "./TicketToRidePlayerView";
import {useNavigate, useLocation} from "react-router-dom";
import axios from "axios";

export const TicketToRidePanel = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const path = location.pathname.replace(/\/+$/, '').split('/');
	const matchId = path[path.length - 1];
	const [gameState, setGameState] = useState({id: -1});
	// Major updates are updates which should immediately be set from remote with no delay.
	const [isMajorUpdating, setIsMajorUpdating] = useState(false);
	const timerRef = useRef(null);
	useEffect(() => {
		axios.get(`/api/m/${matchId}`)
			.then(response => {
				console.log(response)
				if (response.status === 404) {
					navigate('/error/404');
				} else {
					setGameState(response.data)
				}
			})
			.catch(error => {
				navigate('/error/404');
			})
	}, [matchId, navigate]);


	useEffect(() => {
		return () => clearTimeout(timerRef.current);
	}, []);

	const enqueueRemoteUpdate = (data) => {
		clearTimeout(timerRef.current);

		const update = () => {
			setIsMajorUpdating(false);
			setGameState(data);
		}

		if (isMajorUpdating) {
			update();
			return;
		}

		timerRef.current = setTimeout(() => update(), 450);
	}

	const addPlayer = async () => {
		if (isMajorUpdating) {
			return;
		}

		setIsMajorUpdating(true);
		const response = await axios.patch(`/api/m/${matchId}`, {rpc: 'player_instance_append'})
		handleRemoteData(response)
	}

	useEffect(() => {
		const events = new EventSource(`/api/m/sse/${matchId}`);
		events.onmessage = (event) => {
			const parsedData = JSON.parse(event.data);
			setGameState(parsedData);
		};

		return () => {
			events.close();
		}
	}, [matchId]);

	const handleRemoteData = (message) => {
		if (message.status !== 200) {
			console.warn(message.statusText);
			setIsMajorUpdating(false)
			return;
		}

		if (!message.data.hasOwnProperty('data')) {
			console.error('Remote data does not have any data!');
			setIsMajorUpdating(false)
			return;
		}

		enqueueRemoteUpdate(message.data);
	}

	const mutateLocalPlayer = (index, newValue) => {
		const newPlayers = gameState.data['players'].map((player, i) => {
			if (index === i) {
				return newValue;
			} else {
				return player;
			}
		})

		setGameState({
			...gameState,
			data: {
				...gameState.data,
				players: newPlayers
			}
		})
	}

	return (
		<div className="TicketToRidePanel">
			{/* TODO: Text in the top right of the header should state the name of the game in the future */}
			<h1>
				Ticket to Ride Scorecard
			</h1>

			<h3>
				Match ID: {matchId}
			</h3>

			{
				gameState.id === -1 ?
					<p>Loading match...</p> :
					<div className="ttr-players-list">
						{gameState.data['players'].map((data, index) => <TicketToRidePlayerView key={index} data={data} index={index} matchId={matchId} handleRemoteData={handleRemoteData}
																								mutateLocalPlayer={mutateLocalPlayer} isMajorUpdating={isMajorUpdating}
																								setIsMajorUpdating={setIsMajorUpdating}/>)}
					</div>
			}

			{
				gameState.hasOwnProperty('data') ?
					<button disabled={gameState.data['players'].length >= 6 || isMajorUpdating} onClick={addPlayer}>
						Add New Player
					</button> :
					null
			}

			{/* TODO: A tabbl app icon in the header should exit the current game in the future */}
			<button onClick={() => navigate('/')}>
				Stop!
			</button>
		</div>
	);
}